<template>
	<div class="fp_modal fp_modal--postcode" :class="{'fp_modal--active': modal.active}">
		<div class="fp_modal__bg" @click="closeModal"></div>

		<div class="fp_modal__content">
			<div class="fp_modal__close" @click="closeModal">
				Close
			</div>

			<div class="fp_modal__postcode_content">

				<div class="fp_modal__postcode_content--inner" :class="{'fp_modal__postcode_content--active': step.postcode}" v-if="cart == false && checkout == false">

					<p class="fp_modal__h1">Local delivery areas</p>

					<p class="fp_modal__p1">Please refer to the map opposite to see if you are in our ‘local’ delivery areas or simply enter your postcode below to check from our list.</p>

					<input-postcode v-model="postcode" v-bind:postcode_result.sync="postcode_result"></input-postcode>

				</div>
				<div class="fp_modal__postcode_content--inner" :class="{'fp_modal__postcode_content--active': step.postcode}" v-else>

					<p class="fp_modal__h4">How do I get <br>free delivery?</p>

					<ul class="fp_modal__list">
						<li>Spend over £150 for free nationwide delivery</li>
						<li>Spend over £29 for free local delivery</li>
					</ul>

					<p class="fp_modal__small_p">Enter your postcode below to see if you are local</p>

					<input-postcode v-model="postcode" v-bind:postcode_result.sync="postcode_result"></input-postcode>

				</div>


				<div class="fp_modal__postcode_content--inner" :class="{'fp_modal__postcode_content--active': step.local}">

					<p class="fp_modal__h2">You qualify for free local delivery*</p>

					<p class="fp_modal__h3"><span class="fp_modal--orange">Remember</span> to add your post code at checkout.</p>

					<p class="fp_modal__p1">*Spend over £29</p>

					<p class="fp_modal__back" @click="resetSteps()">Go back</p>

				</div>

				<div class="fp_modal__postcode_content--inner" :class="{'fp_modal__postcode_content--active': step.nationwide}">

					<p class="fp_modal__h2">You can use our nationwide service for named day or next day delivery. </p>

					<p class="fp_modal__p2">You are outside our ‘local’ delivery area.</p>

					<p class="fp_modal__back" @click="resetSteps()">Go back</p>

				</div>

			</div>

			<figure class="fp_modal__graphic">

				<div class="delivery_banner__svgwrap">
					<div class="delivery_banner__local">
						<p>Local delivery area</p>
					</div>
					<div class="delivery_banner__nationwide">
						<p>Nationwide delivery area</p>
					</div>
					<img class="delivery_banner__svg" :src="themeurl + '/images/svg/del-map.svg'" alt="">
				</div>

			</figure>

		</div>
	</div>
</template>

<script>
	import InputPostcode from './input-postcode.vue';

	export default {
		components: {
			'input-postcode': InputPostcode
		},
		data: function() {
			return {
				modal: {
					active: false
				},
				postcode: '',
				postcode_result: {},
				step: {
					postcode: true,
					local: false,
					nationwide: false
				},
				themeurl: WPURLS['template_directory'],
				cart: false,
				checkout: false,
			}
		},
		watch: {
			postcode_result: function() {
				this.step.postcode = false;

				if (this.postcode_result['Local'] == true) {
					this.step.local = true;
				} else {
					this.step.nationwide = true;
				}
			}
		},
		computed: {

		},
		created() {

			this.$nextTick(() => {
				jQuery('body').on('click', '.fp_check_postcode', (e) => {
					e.preventDefault();
					this.openModal();
				});

				if (jQuery('body').hasClass('woocommerce-cart')) {
					this.cart = true;
				}
				if (jQuery('body').hasClass('woocommerce-checkout')) {
					this.checkout = true;
				}
			});
		},
		methods: {
			openModal() {
				this.modal.active = true;
				jQuery('.fp_modal--postcode').css('top', window.pageYOffset);
			},
			closeModal() {
				this.modal.active = false;
			},
			resetSteps() {
				this.postcode = '';
				this.step.postcode = true;
				this.step.local = false;
				this.step.nationwide = false;
			}
		}
	}
</script>
